import React from 'react';
import { getMediaUrl } from '../../services/tradeLicenseApi';

const DocumentPreview = ({ doc, onClose }) => {
  const url = getMediaUrl(doc.file_url || doc.file);
  const isImage = /\.(jpe?g|png|gif|webp)(\?|$)/i.test(url)
    || /photo|image/i.test(doc.document_type || '');

  return (
    <div className="doc-preview-overlay" onClick={onClose}>
      <div className="doc-preview-modal" onClick={(e) => e.stopPropagation()}>
        <div className="doc-preview-header">
          <h3>{doc.name_en || doc.document_type?.replace(/_/g, ' ')}</h3>
          <button type="button" className="modal-close" onClick={onClose}>✕</button>
        </div>
        <div className="doc-preview-body">
          {isImage ? (
            <img src={url} alt={doc.name_en || 'Document'} className="doc-preview-image" />
          ) : (
            <iframe title={doc.name_en || 'Document'} src={url} className="doc-preview-frame" />
          )}
        </div>
        <div className="doc-preview-footer">
          <a href={url} target="_blank" rel="noopener noreferrer" className="btn btn-secondary btn-sm">
            ⬇️ Download
          </a>
        </div>
      </div>
    </div>
  );
};

export default DocumentPreview;
